import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FaUsers, FaChartBar, FaSignOutAlt, FaUser } from 'react-icons/fa';
import styled from 'styled-components';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Sidebar = styled.div`
  width: 250px;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 20px 0;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.div`
  text-align: center;
  padding: 20px;
  border-bottom: 1px solid #34495e;
  margin-bottom: 20px;
  
  h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
  }
`;

const NavMenu = styled.nav`
  padding: 0 20px;
`;

const NavItem = styled.div`
  margin-bottom: 10px;
`;

const NavLink = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${props => props.$active ? '#fff' : '#bdc3c7'};
  background: ${props => props.$active ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
  
  svg {
    margin-right: 12px;
    font-size: 18px;
  }
`;

const MainContent = styled.div`
  flex: 1;
  background: #f8f9fa;
`;

const Header = styled.header`
  background: white;
  padding: 15px 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const UserName = styled.span`
  font-weight: 500;
  color: #333;
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: #e74c3c;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  border-radius: 5px;
  transition: all 0.3s ease;
  
  &:hover {
    background: #fdf2f2;
  }
`;

const Content = styled.main`
  padding: 30px;
`;

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: <FaChartBar /> },
    { path: '/clientes', label: 'Clientes', icon: <FaUsers /> },
  ];

  return (
    <LayoutContainer>
      <Sidebar>
        <Logo>
          <h2>Admin Panel</h2>
        </Logo>
        
        <NavMenu>
          {navItems.map((item) => (
            <NavItem key={item.path}>
              <NavLink
                $active={location.pathname === item.path}
                onClick={() => navigate(item.path)}
              >
                {item.icon}
                {item.label}
              </NavLink>
            </NavItem>
          ))}
        </NavMenu>
      </Sidebar>
      
      <MainContent>
        <Header>
          <div>
            <h1 style={{ margin: 0, color: '#333' }}>
              {location.pathname === '/dashboard' && 'Dashboard'}
              {location.pathname === '/clientes' && 'Gestão de Clientes'}
              {location.pathname === '/clients' && 'Gestão de Clientes'}
              {location.pathname.startsWith('/clientes/') && 'Detalhes do Cliente'}
              {location.pathname.startsWith('/clients/') && 'Detalhes do Cliente'}
              {location.pathname === '/clientes/novo' && 'Nova Empresa'}
            </h1>
          </div>
          
          <UserInfo>
            <FaUser />
            <UserName>{user?.name || user?.email || 'Usuário'}</UserName>
            <LogoutButton onClick={handleLogout}>
              <FaSignOutAlt />
              Sair
            </LogoutButton>
          </UserInfo>
        </Header>
        
        <Content>
          {children}
        </Content>
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout; 